<template>
  <div class="commodity_good">
    <Tabs :categoreis="categoreis" :activity="activity"/>
    
  </div>
</template>
<script>
import Tabs from "./commodity/tabs";
export default {
  data() {
    return {};
  },
  props: {
    categoreis: {
      default: function() {
        return [];
      },
      type: Array
    },
    activity:{
      default:function(){
        return {}
      },
      type:Object
    }
  },
  components: { Tabs }
};
</script>
<style lang="less" scoped>
</style>